//          获取url传的参数
function getUrlParam(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
    var r = window.location.search.substr(1).match(reg); //匹配目标参数
    if (r != null) return unescape(r[2]);
    return null; //返回参数值
  }
function confirm(message) {
  var iframe = document.createElement("IFRAME");
  iframe.style.display = "none";
  iframe.setAttribute("src", 'data:text/plain,');
  document.documentElement.appendChild(iframe);
  var alertFrame = window.frames[0];
  var result = alertFrame.window.confirm(message);
  iframe.parentNode.removeChild(iframe);
  return result;
}
function startMover() {//目标值
  let commentInput = document.getElementsByClassName("commentInput")[0];
  let x = document.body.clientX || document.documentElement.clientX;
  let sT = document.body.scrollTop || document.documentElement.scrollTop
  // let y = document.body.clientY || document.documentElement.clientY;
  let y = commentInput.offsetTop + sT;
  // console.log(y)
  let star = document.createElement("div");
  star.innerText = "❤";
  let RandomSize = parseInt(Math.random()*25+25);
  star.style.height = star.style.width = RandomSize + "px";
  star.style.color = '#E51C23';
  star.style.fontSize = RandomSize + "px";
  star.style.position = "absolute";
  star.style.right = 22 + "px";
  star.style.top = y + "px";
  document.body.appendChild(star);
  let op = 100;
  let deg = 0;
  let RandomX = Math.round(Math.random()*13+2);
  let t = setInterval(function(){
    op--;
    deg +=5;
    star.style.top = (star.offsetTop - RandomX) + "px";
    star.style.right = 50*Math.sin(deg*Math.PI/180) + x + "px";
    star.style.opacity = op/100;
    if(star.style.opacity == 0){
      clearInterval(t);
      star.remove();
    }
  },20);
}
function scriptFun() {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?a6dc1757a16356d0d1df93208a984704";
  var s = document.getElementsByTagName("script")[0];
  s.parentNode.insertBefore(hm, s);
}
// 定位

const configData = {
    jumpUrl: 'https://m.ql1d.com/share/module',  //正式
// jumpUrl : 'http://124.128.235.251:8081/qlwb/sharepage/module',  //测试
// jumpUrl : 'http://192.168.1.24:8086/module',  //本地
}
function isAndroid() {
  var u = navigator.userAgent;
  var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
  var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  if (isAndroid) {
    return true;
  } else if (isiOS) {
    return false;
  }
};
  export {getUrlParam,startMover,confirm,scriptFun,configData,isAndroid}



// WEBPACK FOOTER //
// ./src/common/js/common.js